import { useT } from '@transifex/react'
import React from 'react'
import { useAppSelector } from '../../../../../state/hooks'
import { selectCurrentSale } from '../../../../../state/slices/currentSale/currentSaleSlice'
import {
  getDisabledTooltipMessage,
  TooltipContext,
} from '../../add-row-tooltips'

export interface PromoCodeLabelProps {
  disabled: boolean
  onClick: () => void
}

export interface PromoCodeLabelModel {
  disabled: boolean
  onClick: () => void
  tooltipInfo: { title: string; message: React.ReactNode } | null
}

export const usePromoCodeLabelModel = (
  props: PromoCodeLabelProps
): PromoCodeLabelModel => {
  const t = useT()
  const currentSale = useAppSelector(selectCurrentSale)

  const tooltipInfo = props.disabled
    ? getDisabledTooltipMessage(t, currentSale, TooltipContext.PROMOTION) ??
      null
    : null

  return { disabled: props.disabled, onClick: props.onClick, tooltipInfo }
}
